import { OvertimeTypes } from '../models/tournament';
import { Locales } from './locales';

export const OvertimeTypeLocalization = {
  [Locales.ru]: {
    [OvertimeTypes.to_score_diff]: 'До разницы в N мячей',
    [OvertimeTypes.to_score_total]: 'До N очков',
    [OvertimeTypes.time]: 'По времени',
    [OvertimeTypes.without_overtime]: 'Без овертайма',
    [OvertimeTypes.to_first_goal]: 'На N минут до первой шайбы',
    [OvertimeTypes.to_first_goal_and_bullitts]: 'На N минут до первой шайбы + буллиты',
    [OvertimeTypes.bullitts]: 'Буллиты',
    [OvertimeTypes.penalties]: 'Пенальти',
    [OvertimeTypes.time_and_penalties]: 'Дополнительное время + пенальти',
  },
  [Locales.en]: {
    [OvertimeTypes.to_score_diff]: 'Up to the difference of N balls',
    [OvertimeTypes.to_score_total]: 'Up to N points',
    [OvertimeTypes.time]: 'By time',
    [OvertimeTypes.without_overtime]: 'Without overtime',
    [OvertimeTypes.to_first_goal]: 'N minutes until the first goal',
    [OvertimeTypes.to_first_goal_and_bullitts]: 'N minutes until the first goal + shootout',
    [OvertimeTypes.bullitts]: 'Shootouts',
    [OvertimeTypes.penalties]: 'Penalty',
    [OvertimeTypes.time_and_penalties]: 'Extra time + penalty',
  }
};
